import { render } from "./instructor-headerborder.vue?vue&type=template&id=75e534a1"
import script from "./instructor-headerborder.vue?vue&type=script&lang=js"
export * from "./instructor-headerborder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__